export { default } from "./upsPaymentFailedCard";
